var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTransmission = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M18 3c-1.1 0-2 .85-2 1.887 0 .698.4 1.302 1 1.641v4.02h-4v-4.02c.6-.32 1-.943 1-1.641C14 3.849 13.1 3 12 3s-2 .85-2 1.887c0 .698.4 1.302 1 1.641v4.02H7v-4.02c.6-.32 1-.943 1-1.641C8 3.849 7.1 3 6 3s-2 .85-2 1.887c0 .698.4 1.302 1 1.641v9.944c-.6.32-1 .943-1 1.641C4 19.151 4.9 20 6 20s2-.85 2-1.887c0-.698-.4-1.302-1-1.641v-4.038h4v4.019c-.6.32-1 .943-1 1.641 0 1.038.9 1.887 2 1.887s2-.849 2-1.887c0-.698-.4-1.302-1-1.641v-4.019h6V6.528c.6-.32 1-.943 1-1.641C20 3.849 19.1 3 18 3"
})));
export default SvgTransmission;